// extracted by mini-css-extract-plugin
export default {"Container":"latestNews_Container__J38k-","Card":"latestNews_Card__WlGs-"};